export default {
  heroTitle: 'Arkusz USFans — kompletne źródło informacji o produktach, sprzedawcach, QC i wysyłce',
  heroSubtitle: 'Poznaj najnowsze zasoby arkusza USFans, poradniki produktowe, informacje o sprzedawcach, wskazówki QC, informacje o wysyłce i przydatne zasoby zakupowe — wszystko w jednym wygodnym miejscu.',
  heroTrust: 'Aktualne zasoby • Praktyczne poradniki • Niezależne informacje',
  readGuide: 'Przeczytaj pełny poradnik',

  whatTitle: 'Czym jest arkusz USFans?',
  whatCopy: 'Arkusz USFans to wygodny sposób na uporządkowanie i przeglądanie przydatnych zasobów o produktach, sprzedawcach i zakupach. Nasz niezależny ośrodek pomaga poruszać się po informacjach związanych z arkuszem, badaniu produktów, kontroli jakości, wysyłce i innych przydatnych poradnikach USFans bez marnowania czasu na szukanie w wielu źródłach.',
  exploreSpreadsheet: 'Przeglądaj arkusz',

  resourcesTitle: 'Poznaj zasoby arkusza USFans',
  resourcesSubtitle: 'Uporządkowane poradniki na każdym etapie poszukiwań, od odkrycia po dostawę.',
  resource1Title: 'Arkusz USFans',
  resource1Desc: 'Znajdź uporządkowane zasoby arkusza i przydatne informacje o produktach.',
  resource2Title: 'Sprzedawcy USFans',
  resource2Desc: 'Poznaj zasoby o sprzedawcach i dowiedz się, jak oceniać oferty.',
  resource3Title: 'Poradnik QC USFans',
  resource3Desc: 'Dowiedz się, co sprawdzić przed dokonaniem zakupu.',
  resource4Title: 'Wysyłka USFans',
  resource4Desc: 'Poznaj metody wysyłki, koszty, kwestie dostawy i najczęstsze pytania.',
  resource5Title: 'Magazyn USFans',
  resource5Desc: 'Dowiedz się, jak działa magazynowanie, kontrola i obsługa produktów.',
  resource6Title: 'Recenzja USFans',
  resource6Desc: 'Poznaj niezależny przegląd funkcji, użyteczności i najczęstszych pytań o USFans.',

  whyTitle: 'Wszystko, czego potrzebujesz do badań nad USFans, w jednym miejscu',
  whyCopy: 'Szukanie informacji o USFans bywa czasochłonne, gdy przydatne zasoby są rozproszone po różnych stronach. USFansLink łączy powiązane poradniki, zasoby arkusza, informacje o sprzedawcach, wskazówki QC, informacje o wysyłce i wskazówki bezpieczeństwa w jeden uporządkowany ośrodek.',
  benefit1: 'Uporządkowane zasoby arkusza USFans',
  benefit2: 'Łatwe poradniki zakupowe',
  benefit3: 'Informacje o wysyłce i magazynie',
  benefit4: 'Poradniki QC i badań produktowych',
  benefit5: 'Aktualne treści edukacyjne',
  benefit6: 'Niezależne informacje o bezpieczeństwie',

  featuredTitle: 'Zacznij od poradnika o arkuszu USFans',
  featuredCopy: 'Jesteś nowy w USFans? Zacznij od naszego kompletnego poradnika o arkuszu. Dowiedz się, jak poruszać się po zasobach, badać produkty, rozumieć informacje o sprzedawcach, przeglądać szczegóły QC i znaleźć potrzebne informacje przed podjęciem decyzji.',

  reviewTitle: 'Recenzja USFans: co warto wiedzieć',
  reviewCopy: 'Szukasz obiektywnego przeglądu? Nasza recenzja USFans obejmuje kluczowe tematy, które najczęściej interesują użytkowników, w tym użyteczność, odkrywanie produktów, procesy magazynowe, wysyłkę, koszty, kwestie bezpieczeństwa i najczęstsze pytania.',
  readReview: 'Przeczytaj recenzję USFans',

  safetyTitle: 'Zachowaj bezpieczeństwo podczas przeglądania zasobów USFans',
  safetyCopy: 'Chroń swoje konto i dane osobowe. Nigdy nie udostępniaj haseł, kodów weryfikacyjnych ani danych płatniczych przez niezweryfikowane kanały. Zawsze dokładnie sprawdzaj linki i korzystaj z bezpiecznych witryn przed podaniem poufnych informacji.',
  readSafety: 'Przeczytaj poradnik bezpieczeństwa USFans',

  articlesTitle: 'Najnowsze artykuły o arkuszu USFans',
  articlesSubtitle: 'Oryginalne, szczegółowe poradniki, które pomogą Ci prowadzić badania z pewnością.',
  article1Title: 'Arkusz USFans: kompletny poradnik, linki i zasoby 2026',
  article1Desc: 'Wszystko, co musisz wiedzieć o poruszaniu się po zasobach arkusza, badaniu produktów, QC, wysyłce i nie tylko.',
  articleReadMore: 'Czytaj artykuł',

  finalTitle: 'Gotowy na poznanie zasobów arkusza USFans?',
  finalCopy: 'Znajdź przydatne poradniki, zasoby arkusza, informacje o sprzedawcach, wskazówki QC i informacje o wysyłce w jednym miejscu.',
};